import React, { Component } from 'react';
import { Header } from './header.js';
import { Footer } from './footer.js';
import * as util from './util';
import { logBusinessActivities } from './business_activities';
import './new-software.css';
import { FeeBoxXU } from './feebox-xu';


import ResearchSoftwareMinimalDatePicker from './researchSoftwareMinimalDatePicker';
import { CategorySelectorList } from './category-selector-rewrite';

import { TextInfo, TextLine, TextField, Price, Confirmed, ConfirmedText, ConfirmedTextWithPrice, Selection, Tags,
         ComplexityRate, CheckBox, AGBCheckBox, SubmitButton, IntegerField, MultipleFileUpload } from './common-form-components.js';

var introductoryTextNonCom = '<p>An dieser Stelle können Sie Software, Software-Module, spezielles Customizing eines Systems, Excel-Programmierungen und vieles mehr einstellen.<br/>Alles, was das weite Feld Software betrifft - sofern es kein Medizinprodukt ist. <br />Also z.B. auch Maskenabfolgen und Codes für einen Spezialbereich im klinischen Informationssystem. Oder ein Controlling-Excel-Sheet, das seit Jahren ausgereift ist. Aber ebenso eine technische Spezifikation oder ein Leistungsverzeichnis, das für andere nützlich sein kann.<br/> <br/><p> Eine kleine Anzahl der Felder sind mit einem "*" gekennzeichnet und <u>müssen</u> ausgefüllt werden. Alle weiteren Felder sind freiwillig. Diese können für mögliche Kunden von Interesse sein.</p>';

var introductoryTextCom ='<p>An dieser Stelle können Sie Software, Software-Module, spezielles Customizing eines Systems, Excel-Programmierungen und vieles mehr einstellen.<br/><br /> Alles, was das weiter Feld Software betrifft - sofern es kein Medizinprodukt ist. <br /><br />Also z.B. auch Maskenabfolgen und Codes für einen Spezialbereich im klinischen Informationssystem. Oder ein Controlling-Excel-Sheet, das seit Jahren ausgereift ist. Aber ebenso eine technische Spezifikation oder ein Leistungsverzeichnis, das für andere nützlich sein kann.<br /><br >Sie bezahlen eine Gebühr für das Einstellen in den Marktplatz und die oder der Suchende bekommt bei der Ergebnisanzeige Ihre vollständigen Daten.<br /><br />Als kommerzieller Anbieter ist selbstverständlich <u>keine</u> Offenlegung des Codes gefordert.<br/> <br/><p> Eine kleine Anzahl der Felder sind mit einem "*" gekennzeichnet und <u>müssen</u> ausgefüllt werden. Alle weiteren Felder sind freiwillig. Diese können für mögliche Kunden von Interesse sein.</p>';

var checkBoxInfo="Wenn Sie ein nicht kommerzielles Produkt anlegen, ist es erforderlich, dem Käufer den Quell-Code zur Verfügung zu stellen. (Der Quellcode wird nicht weiterverkauft.) Nur so kann Ayacandas die Gewährleistung übernehmen."

let faqSoftware = [
  {
    content: "Der Käufer soll und muss die Möglichkeit haben, das Produkt, das er kauft, an seine Bedürfnisse anzupassen. Dies ist meist bereits technisch notwendig, um Software zum Laufen zu bekommen. ",
    title: "Warum müssen Software-Produkte quelloffen weitergegeben werden?",
    key: 0
  },
  {
    content: "Dies wird im Kaufvertrag ausdrücklich und unter Vertragsstrafe untersagt. Der Käufer darf das Produkt für sich selbst verwenden und anpassen..",
    title: "Kann der Käufer das Produkt weiterverkaufen? ",
    key: 1
  },
  {
    content: "Wenn eine neue und wesentlich veränderte Version in den Marktplatz von Ayacandas eingestellt wird - eine echte Weiterentwicklung - , bekommt der neue Verkäufer 30% fest. Die restlichen 70% werden unter allen Schreibern vorheriger Versionen paritätisch aufgeteilt.",
    title: "Was ist, wenn der Käufer das Produkt essentiell weiterentwickelt und damit eine neue Version erstellt?",
    key: 2
  },
  {
    content: "Bitte melden Sie Sich bei uns - wir werden umgehend versuchen, eine Lösung zu finden und den Angebotsbaum erweitern.",
    title: "Was ist, wenn eine Kategorie nicht auffindbar ist oder fehlt? ",
    key: 3
  },
  {
    content: "Ein Weiterverkauf innerhalb der meisten Förderprogramme ist unproblematisch, da er den Förderzweck nicht entfremdet. Ein Weiterverkauf verstößt somit <u>nicht</u> gegen die Bedingungen des Förderbescheids. Eine Mehrwerterschaffung sollte jedoch von der jeweiligen  Klinik an das zuständige Ministerium gemeldet werden.<br /><br />Das Anbieten ist unkritisch, sofern vom ursprünglichen Förderbescheid kein Geld entwendet oder veräußert wird und nicht gegen die Begutachtungslinie der DFG gehandelt wird. In diesem Zusammenhang darf nur Eigenleistung verkauft werden.",
    title: "Gibt es Probleme, wenn das Produkt mit der Hilfe von Förderbescheiden entwickelt wurde?",
    key: 4
  },
  {
    content: "Einnahmen gehen, falls Sie nicht als Privatperson verkaufen, oft nicht an Sie, sondern an die Institution, in deren Namen Sie verkaufen. Solche Einnahmen können Sie Sich im Rahmen des Controllings als eigene Einnahmen durch Verrechnung gutschreiben lassen.",
    title: "Was habe ich davon, wenn ich für meine Institution etwas verkaufe - das Geld gehört doch dann weder mir noch meiner Abteilung?",
    key: 5
  }
];

var softwareTypes = [
  <option key='6'>bitte wählen...</option>,
  <option key='0'>Kliniken</option>,
  <option key='1'>Praxen</option>,
  <option key='2'>MVZ</option>,
  <option key='3'>Kleingruppen</option>,
  <option key='4'>Einzelpersonen</option>,
  <option key='5'>sonstige/keine Auslegung</option>
];
var complexityRate = [
  <option key='0'>bitte wählen...</option>,
  <option key='1'>1 - niedrige Komplexität</option>,
  <option key='2'>2 - </option>,
  <option key='3'>3 - </option>,
  <option key='4'>4 - </option>,
  <option key='5'>5 - mittlere Komplexität</option>,
  <option key='6'>6 - </option>,
  <option key='7'>7 - </option>,
  <option key='8'>8 - </option>,
  <option key='9'>9 - </option>,
  <option key='10'>10 - hohe Komplexität</option>];

var satisfactionRate = [
  <option key='0'>bitte wählen...</option>,
  <option key='1'>Sehr zufrieden</option>,
  <option key='2'>Zufrieden</option>,
  <option key='3'>Weniger zufrieden</option>,
  <option key='4'>Unzufrieden</option>,
];

export class CreateSoftware extends Component {
  constructor(props) {
    super(props);
    this.fetchDataAndRedirect = this.fetchDataAndRedirect.bind(this);
    this.fetchDataAndRedirect();
  }

  fetchDataAndRedirect() {
    const self = this;
    var headers = util.defaultHeaders();
    headers.append("Accept", "application/json");
    headers.append('Content-Type', 'application/x-www-form-urlencoded');
    var url = `/api/new-create-software`;
    var promise = fetch(url, {method: 'POST',
                              headers: headers,
                              body: ''
    })
      .then(response => response.json())
      .catch(function(exception) {
        alert('Konnte keine neue Software anlegen!');
        console.error(`Could not create new software!`, exception);
      });
    promise.then(function(json) {
      self.props.history.replace(`/update-software/${json.id}`);
    });
  }

  render() {
    return(
      <div className="CreateSoftware">
      </div>
    )
  }
}

export class UpdateSoftwareWithFeebox extends Component {
  constructor(props) {
    super(props);
    this.updateFeeByPrice = this.updateFeeByPrice.bind(this);
    this.updateFeeByCategories = this.updateFeeByCategories.bind(this);
    this.countCategories = this.countCategories.bind(this);
    this.state={price: 0,
                categoryCount: 1};
  }

  updateFeeByPrice(price) {
    this.setState({price: price});
    return true;
  }

  updateFeeByCategories (categories) {
    this.setState ({categoryCount:this.countCategories(categories)});
    return true;
  }


  countCategories(categories) {
   // workaround: converting String to array (FIXME)
   if ((typeof categories ) === 'string') {
    categories = categories.split(",");
  }
   console.log(categories);
   var tempCats = [];
   var count = 0;
   for (let i = 0; i < 6; i++) {
    if (categories !== undefined && categories[i] !== null && categories[i] !== "" ) {
      if (!tempCats.includes(categories[i])) {
        tempCats.push(categories[i]);
        count = count+1;
      } 
    }
  }
  return count;
  }


  render() {
    return (
      <div className="UpdateSoftwareWithFeebox" >
        <UpdateSoftware history={this.props.history} match={this.props.match} params={this.props.params} updateFeeByPrice={this.updateFeeByPrice} updateFeeByCategories={this.updateFeeByCategories}
                        onNewMessage={this.props.onNewMessage} />
        {util.isCommercialUser() &&
         <FeeBoxXU type="software" price={this.state.price} categoryCount={this.state.categoryCount} />}
      </div>
    )
  }
}


export class UpdateSoftware extends Component {
  constructor(props) {
    super(props);
    this.fetchDataAndRedirect = this.fetchDataAndRedirect.bind(this);
    this.update = this.update.bind(this);
    this.validateInput = this.validateInput.bind(this);
    this.checkRequiredFields = this.checkRequiredFields.bind(this);
    this.isValid = this.isValid.bind(this);
    this.save = this.save.bind(this);

    this.state = {
      startID: 2,
      id: null,
      name: '',
      categories: '',
      price: 0,
      aim: '',
      tags: '',
      standalone_sw: '',
      is_standalone_sw: '',
      agreement: false,
      direct_database_access: null,
      direct_database_access_desc: '',
      has_additional_interface: null,
      additional_interface: '',
      has_additional_licence: null,
      additional_licence: '',
      data_component_complete: false,
      data_component_options: '',
      data_manipulation: '',
      data_manipulation_protocol: '',
      manipulation_authorised: null,
      manipulation_authorised_desc: '',
      data_update_interval: 0,
      has_update_side_effect: false,
      update_side_effect: '',
      has_release_plan: '',
      release_plan: '',
      is_preparation_needed: '',
      preparation_needed: '',
      has_customer_reference: '',
      customer_reference: '',
      successful_deployment: null,
      successful_deployment_description: '',
      clinic_desc: '',
      clinic_number: 0,
      user_number: 0,
      complexity_rate: 0,
      date: '',
      satisfaction_rate: 0,
      rating_desc: '',
      agb_agreement: false,
      is_public: false,
      is_update_available: false,
      update_price: '',
      update_price_text: '',
      target_group: '',
      pdf_files: ',,,,',
      image_files: ',,,,,,,,,',
      video_files: '',
      product_files:'',
      agreement_1: false,
      agreement_2: false,
      agreement_3: false,
      agreement_4: false,
      agreement_5: false,
      agreement_6: false,

    };

    this.fetchDataAndRedirect();
    this.globalFormData = {};
  }

  shouldComponentUpdate(nextProps, nextState) {
    if (nextState !== this.state) {
      return true;
    } else {
      return false;
    }
  }

  update(slot, value) {
    if(slot === 'price' && this.props.updateFeeByPrice !== undefined) {
      this.props.updateFeeByPrice(parseInt(value, 10));
    }
    if(slot === 'categories' && this.props.updateFeeByCategories !== undefined) {
      this.props.updateFeeByCategories(value);
    }

    this.globalFormData[slot] = value;
  }


  fetchDataAndRedirect() {
    var id = this.props.match.params.id;
    const self = this;
    var headers = util.defaultHeaders();
    headers.append("Accept", "application/json");
    headers.append('Content-Type', 'application/x-www-form-urlencoded');
    var url = `/api/new-create-software`;
    var promise = fetch(url, {
      method: 'POST',
      headers: headers,
      body: `id=${id}`
    })
      .then(response => response.json())
      .catch(function (exception) {
        alert('Konnte keine Werte laden!');
        console.error(`Could not retrieve researchsoftware data!`, exception);
      });
    promise.then(function (json) {
      self.setState({
        id: json.id,
        name: json.name,
        desc: json.desc,
        categories: json.categories,
        price: json.price,
        aim: json.aim,
        tags: json.tags,
        standalone_sw: json.standalone_sw,
        is_standalone_sw: json.is_standalone_sw,
        agreement: json.agreement,
        direct_database_access: json.direct_database_access,
        direct_database_access_desc: json.direct_database_access_desc,
        has_additional_interface: json.has_additional_interface,
        additional_interface: json.additional_interface,
        has_additional_licence: json.has_additional_licence,
        additional_licence: json.additional_licence,
        data_component_complete: json.data_component_complete,
        data_component_options: json.data_component_options,
        data_manipulation: json.data_manipulation,
        data_manipulation_protocol: json.data_manipulation_protocol,
        manipulation_authorised: json.manipulation_authorised,
        manipulation_authorised_desc: json.manipulation_authorised_desc,
        data_update_interval: json.data_update_interval,
        has_update_side_effect: json.has_update_side_effect,
        update_side_effect: json.update_side_effect,
        has_release_plan: json.has_release_plan,
        release_plan: json.release_plan,
        is_preparation_needed: json.is_preparation_needed,
        preparation_needed: json.preparation_needed,
        has_customer_reference: json.has_customer_reference,
        customer_reference: json.customer_reference,
        successful_deployment: json.successful_deployment,
        successful_deployment_description: json.successful_deployment_description,
        clinic_desc: json.clinic_desc,
        clinic_number: json.clinic_number,
        user_number: json.user_number,
        complexity_rate: json.complexity_rate,
        date: json.date,
        satisfaction_rate: json.satisfaction_rate,
        rating_desc: json.rating_desc,
        agb_agreement: json.agb_agreement,
        is_public: json.is_public,
        is_update_available: json.is_update_available,
        update_price: json.update_price,
        update_price_text: json.update_price_text,
        target_group: json.target_group,
        pdf_files: json.pdf_files,
        image_files: json.image_files,
        video_files: json.video_files,
        product_files: json.product_files,
        agreement_1: json.agreement_1,
        agreement_2: json.agreement_2,
        agreement_3: json.agreement_3,
        agreement_4: json.agreement_4,
        agreement_5: json.agreement_5,
        agreement_6: json.agreement_6,
      });
    })
  }

  isValid(categories) {

    if (categories === undefined)
      return false;

    if (categories === null)
      return false;

    if (categories === "")
      return false;

    if (typeof categories === 'string') {
      categories = categories.split(/,/);
    }

    var catInput = categories.map(item => parseInt(item, 10));
    for (var i = 0; i < categories.length; i++) {
      if (parseInt(catInput[i], 10) === catInput[i]) {
        return true;
      }
    }
    return false;
  }

  validateInput() {
    if (this.globalFormData['name'] === undefined) {
      if (this.state.name.length > 200) {
        alert("Der Name ist zu lang, bitte beschränken Sie sich auf 200 Zeichen.");
        return false;
      }
    } else {
      if (this.globalFormData['name'].length < 1) {
        alert("Der Name ist ein Pflichtfeld. Bitte geben Sie Ihrem Angebot einen Namen.");
        return false;
      }
      if (this.globalFormData['name'].length > 200) {
        alert("Der Name ist zu lang, bitte beschränken Sie sich auf 200 Zeichen.");
        return false;
      }
    }

    if (this.globalFormData['aim'] === undefined) {
      if (this.state.aim.length < 1) {
        alert("Die Beschreibung ist ein Pflichtfeld. Bitte beschreiben Sie Ihr Angebot.");
        return false;
      }
      if (this.state.aim.length > 2000) {
        alert("Die Beschreibung ist zu lang, bitte beschränken Sie sich auf 2000 Zeichen.");
        return false;
      }
    } else {
      if (this.globalFormData['aim'].length < 1) {
        alert("Die Beschreibung ist ein Pflichtfeld. Bitte beschreiben Sie Ihr Angebot.");
        return false;
      }
      if (this.globalFormData['aim'].length > 2000) {
        alert("Die Beschreibung ist zu lang, bitte beschränken Sie sich auf 2000 Zeichen.");
        return false;
      }
    }
    return true;
  }

  checkRequiredFields() {
    if (this.globalFormData['name'] === undefined) {
      if (this.state.name.length < 1) {
        alert("Der Name ist ein Pflichtfeld. Bitte geben Sie Ihrem Angebot einen Namen.");
        return false;
      }
    } else {
      if (this.globalFormData['name'].length < 1) {
        alert("Der Name ist ein Pflichtfelder. Bitte geben Sie Ihrem Angebot einen Namen.");
        return false;
      }
    }

    if ((this.globalFormData['categories'] === undefined) && (!this.isValid(this.state.categories))) {
      alert("Geben Sie wenigstens eine und bis zu sechs Kategorien an.");
      return false;
    }
    if (!this.isValid(this.globalFormData['categories'])) {
      alert("Geben Sie wenigstens eine und bis zu sechs Kategorien an.");
      return false;
    }

    if (this.globalFormData['aim'] === undefined) {
      if (this.state.aim.length < 1) {
        alert("Der Zweck ist ein Pflichtfeld. Bitte beschreiben Sie Ihr Angebot.");
        return false;
      }
    } else {
      if (this.globalFormData['aim'].length <1) {
        alert("Der Zweck ist ein Pflichtfeld. Bitte beschreiben Sie Ihr Angebot.");
        return false;
      }
    }

    if (this.globalFormData['price'] === undefined) {
      if (this.state.price.length === 0) {
        alert("Der Preis ist ein Pflichtfeld. Bitte geben Sie den Preis an.");
        return false;
      }
    } else {
      if (this.globalFormData['price'].length === 0) {
        alert("Der Preis ist ein Pflichtfeld. Bitte geben Sie den Preis an.");
        return false;
      }
    }

    /*
       if (this.globalFormData['is_public'] === undefined) {
       if (this.state.is_public !== true) {
       alert("Bitte geben Sie an, ob die Software aus einer öffentlichen Instutition angeboten wird.");
       return false;
       }
       }

       if (this.globalFormData['is_public'] === false) {
       alert("Bitte geben Sie an, ob die Software aus einer öffentlichen Instutition angeboten wird.");
       return false;
       }

     */

    /*
       if (this.globalFormData['agreement'] === undefined) {
       if (this.state.agreement !== true) {
       alert("Bitte stimmen Sie der Erklärung zu.0");
       return false;
       }
       }

       if (this.globalFormData['agreement'] === false) {
       alert("Bitte stimmen Sie der Erklärung zu.0");
       return false;
       }
     */

    /*
       if (this.globalFormData['agreement_1'] === undefined) {
       if (this.state.agreement_1 !== true) {
       alert("Bitte stimmen Sie der Erklärung zu.1");
       return false;
       }
       }

       if (this.globalFormData['agreement_1'] === false) {
       alert("Bitte stimmen Sie der Erklärung zu.1");
       return false;
       }
     */

    if (this.globalFormData['agreement_2'] === undefined) {
      if (this.state.agreement_2 !== true) {
        alert("Bitte stimmen Sie der Erklärung zu.");
        return false;
      }
    }

    if (this.globalFormData['agreement_2'] === false) {
      alert("Bitte stimmen Sie der Erklärung zu.");
      return false;
    }

    if (this.globalFormData['agreement_3'] === undefined) {
      if (this.state.agreement_3 !== true) {
        alert("Bitte stimmen Sie der Erklärung zu.");
        return false;
      }
    }

    if (this.globalFormData['agreement_3'] === false) {
      alert("Bitte stimmen Sie der Erklärung zu.");
      return false;
    }



    if (this.globalFormData['agreement_4'] === undefined) {
      if (this.state.agreement_4 !== true) {
        alert("Bitte stimmen Sie der Erklärung zu.");
        return false;
      }
    }

    if (this.globalFormData['agreement_4'] === false) {
      alert("Bitte stimmen Sie der Erklärung zu.");
      return false;
    }

    if (!util.isCommercialUser()){
      if (this.globalFormData['agreement_5'] === undefined) {
        if (this.state.agreement_5 !== true) {
          alert("Bitte stimmen Sie der Erklärung zu.");
          return false;
        }
      }

      if (this.globalFormData['agreement_5'] === false) {
        alert("Bitte stimmen Sie der Erklärung zu.");
        return false;
      }
    }


    if (this.globalFormData['agreement_6'] === undefined) {
      if (this.state.agreement_6 !== true) {
        alert("Bitte stimmen Sie der Erklärung zu.");
        return false;
      }
    }

    if (this.globalFormData['agreement_6'] === false) {
      alert("Bitte stimmen Sie der Erklärung zu.");
      return false;
    }



    if (this.globalFormData['agb_agreement'] === false) {
      alert("Bitte bestätigen Sie, dass Sie die Vereinbarung zu Kenntnis genommen haben.");
      return false;
    }

    if (this.globalFormData['agb_agreement'] === undefined) {
      if (this.state.agb_agreement !== true) {
        alert("Bitte bestätigen Sie, dass Sie die Vereinbarung zu Kenntnis genommen haben.");
        return false;
      }
    }

    return true;
  }

  save(announce) {
    if (announce === true) {
      if (this.checkRequiredFields() === false) {
        return;
      }
    }

    if (announce === true) {
      if (this.validateInput() === false) {
        return;
      }
    }
    const self = this;
    var headers = util.defaultHeaders();
    headers.append("Accept", "application/json");
    var formData = new FormData();
    Object.keys(this.globalFormData).map(key => formData.append(key, self.globalFormData[key]));
    formData.append("id", this.state.id);
    if (announce === true) {
      formData.append('announce', true);
    } else {
      formData.append('announce', false);
    }
    formData.append('active', true);
    var url = `/api/new-update-software`;
    var promise = fetch(url, {
      method: 'POST',
      headers: headers,
      body: formData
    })
      .then(response => response.json())
      .catch(function (exception) {
        alert('Konnte keine Werte speichern!');
        console.error(`Could not save researchsoftware data!`, exception);
      });
    promise.then(function (json) {
      alert('Werte wurden gespeichert.');
      if (announce === true) {
        logBusinessActivities("Software gespeichert, allem zugestimmt und veroeffentlicht.", json.id);
      }
      self.globalFormData = {};
      self.setState({
        id: json.id,
        name: json.name,
        desc: json.desc,
        categories: json.categories,
        price: json.price,
        aim: json.aim,
        tags: json.tags,
        standalone_sw: json.standalone_sw,
        is_standalone_sw: json.is_standalone_sw,
        agreement: json.agreement,
        direct_database_access: json.direct_database_access,
        direct_database_access_desc: json.direct_database_access_desc,
        has_additional_interface: json.has_additional_interface,
        additional_interface: json.additional_interface,
        has_additional_licence: json.has_additional_licence,
        additional_licence: json.additional_licence,
        data_component_complete: json.data_component_complete,
        data_component_options: json.data_component_options,
        data_manipulation: json.data_manipulation,
        data_manipulation_protocol: json.data_manipulation_protocol,
        manipulation_authorised: json.manipulation_authorised,
        manipulation_authorised_desc: json.manipulation_authorised_desc,
        data_update_interval: json.data_update_interval,
        has_update_side_effect: json.has_update_side_effect,
        update_side_effect: json.has_update_side_effect,
        has_release_plan: json.has_release_plan,
        release_plan: json.release_plan,
        is_preparation_needed: json.is_preparation_needed,
        preparation_needed: json.preparation_needed,
        has_customer_reference: json.has_customer_reference,
        customer_reference: json.customer_reference,
        successful_deployment: json.successful_deployment,
        successful_deployment_description: json.successful_deployment_description,
        clinic_desc: json.clinic_desc,
        clinic_number: json.clinic_number,
        user_number: json.user_number,
        complexity_rate: json.complexity_rate,
        date: json.date,
        satisfaction_rate: json.satisfaction_rate,
        rating_desc: json.rating_desc,
        agb_agreement: json.agb_agreement,
        is_public: json.is_public,
        is_update_available: json.is_update_available,
        update_price: json.update_price,
        update_price_text: json.update_price_text,
        target_group: json.target_group,
        pdf_files: json.pdf_files,
        image_files: json.image_files,
        video_files: json.video_files,
        product_files: json.product_files,
        agreement_1: json.agreement_1,
        agreement_2: json.agreement_2,
        agreement_3: json.agreement_3,
        agreement_4: json.agreement_4,
        agreement_5: json.agreement_5,
        agreement_6: json.agreement_6,
      });
      self.props.history.push('/product-list');
    })
  }
  render() {
    return (
      <div>
        {(util.isNonCommercialUser() || util.isCommercialUser()) &&
          <div className="Landing" id="contentId">
          <Header username={this.props.username} propagateLogin={this.props.propagateLogin} />
          <div className="ContentWithBackground">
             <div className="content" id="content">
               <div className="productHeader1" id="toplanding">
               Anbieten einer Software
               </div>
              
               {!util.isCommercialUser() &&
               <div className="productHeader2">
                 Nach abgeschlossener Einstellung Ihres Angebotes bleibt
                 dieses für ein Jahr auf der Ayacandas.com zum angegebenen
                 Preis auffindbar.
                 <TextInfo content={introductoryTextNonCom} />
                 </div>}
                 {util.isCommercialUser() &&
                 <div className="productHeader2">
                 Nach abgeschlossener Einstellung Ihres Angebotes bleibt
                 dieses für ein Jahr auf der Ayacandas.com zum angegebenen
                 Preis auffindbar.
                 <TextInfo content={introductoryTextCom} />
                 </div>}
       

       <div className="productForm1  marginTop30">
          <div className="prodInputComp">
         <CategorySelectorList value={this.state.categories} slot="categories" update={this.update} categoryLimit={6} />
         <TextLine heading=" Was bieten Sie an?" subheading="Unter diesem Titel wird ihr Produkt angezeigt." obligatory={true} maxLength='200' value={this.state.name} placeholder="was bieten Sie an" slot='name' update={this.update} />
         <TextField heading="Beschreibung?" obligatory={true} maxLength='2000' placeholder="Zweck der Software" value={this.state.aim} slot='aim' update={this.update} />
         {!util.isCommercialUser() && <Price heading="Preis in Euro"
                                             subheading="85% des Netto-Preises, den Ayacandas durch den Weiterverkauf Ihres Produktes erzielt, wird Ihnen oder Ihrer Institution für das Zurverfügungstellen der Lizenz ausbezahlt." obligatory={true} maxLength='6' value={this.state.price} slot='price' update={this.update} />}

         {util.isCommercialUser() && <Price heading="Preis in Euro"
                                            subheading="Möchten Sie keine Preis-Angabe machen, dann geben Sie bitte 99999 an."
                                            obligatory={true} maxLength='6' value={this.state.price} slot='price' update={this.update} />}
         <Confirmed obligatory={true} heading="Wird diese Software von einer öffentlichen Organistation angeboten? (Beispielsweise von einer Gemeinde, Kommune, Universität, Anstalt eines Landes)" value={this.state.is_public} slot='is_public' update={this.update} />
         <ConfirmedText heading="Ist die Software ein eigenständiges Produkt (d.h sie ist kein Add-On)?" placeholder="Beschreibung" value={this.state.is_standalone_sw} value2={this.state.standalone_sw} slot='is_standalone_sw' slot2='standalone_sw' update={this.update} />
         <ConfirmedTextWithPrice heading="Gibt es Wartungen oder Updates?"
                                 heading2="Falls ja, zu welchen Kosten pro Jahr?" placeholder="Update/Wartung"
                                 value={this.state.is_update_available} value3={this.state.update_price} value4={this.state.update_price_text}
                                 slot='is_update_available'  slot3='update_price' slot4='update_price_text' update={this.update} />
         <Selection heading="Für welche Einrichtung	ist das Produkt primär ausgelegt?"
                    selectionValues={softwareTypes} obligatory={false} value={this.state.target_group} slot='target_group' update={this.update} />
         <Tags heading="Stichworte, um gefunden zu werden (max. 7, durch Komma getrennt)" placeholder="Tags/Stichworte" value={this.state.tags} slot='tags' update={this.update} match={this.props.match} params={this.props.params} maxTags={7} maxLength={150} onNewMessage={this.props.onNewMessage} />
         <MultipleFileUpload heading="Anhang: Dokumente, vorzugsweise als PDF-Datei (bitte nur fachliches Material)" value={this.state.pdf_files} slot="pdf_files" update={this.update} onNewMessage={this.props.onNewMessage} />
         <MultipleFileUpload heading="Anhang: Beschreibende Bilder oder Screenshots" value={this.state.image_files} slot="image_files" update={this.update} onNewMessage={this.props.onNewMessage} />
         <MultipleFileUpload heading="Anhang: Video, max. 5 GB" value={this.state.video_files} slot="video_files" update={this.update} onNewMessage={this.props.onNewMessage} />
         <ConfirmedText heading="Braucht die Software einen direkten Zugriff auf die Datenbank? Wenn ja, beschreiben Sie die Zugriffsart." placeholder="Beschreibung" value={this.state.direct_database_access} value2={this.state.direct_database_access_desc} slot='direct_database_access' slot2='direct_database_access_desc' update={this.update} />
         <ConfirmedText heading="Werden zusätzliche Schnittstellen benötigt?" placeholder="Beschreibung" value={this.state.has_additional_interface} value2={this.state.additional_interface} slot='has_additional_interface' slot2='additional_interface' update={this.update} />
         <ConfirmedText heading="Werden zusätzliche Lizenzen benötigt?" placeholder="Beschreibung" value={this.state.has_additional_licence} value2={this.state.additional_licence} slot='has_additional_licence' slot2='additional_licence' update={this.update} />
         <ConfirmedText heading="Werden alle Elemente für den Datenzugriff mitgeliefert? Welche Möglichkeiten bieten Sie an?" placeholder="Beschreibung"
                        value={this.state.data_component_complete} value2={this.state.data_component_options} slot='data_component_complete' slot2='data_component_options' update={this.update} />
         <ConfirmedText heading="Werden Daten am Quellsystem manipuliert oder verändert? Falls ja: Wie wird dies protokolliert?" placeholder="Beschreibung"
                        value={this.state.data_manipulation} value2={this.state.data_manipulation_protocol} slot='data_manipulation' slot2='data_manipulation_protocol' update={this.update} />
         <ConfirmedText heading="Erfolgt der Zugriff auf die Datenquelle über von Entwicklern zugelassene Zugriffsmethoden?" placeholder="Beschreibung" value={this.state.manipulation_authorised} value2={this.state.manipulation_authorised_desc} slot='manipulation_authorised' slot2='manipulation_authorised_desc' update={this.update} />
         <IntegerField heading="Falls eine „synchrone Schnittstelle“ aktiv ist: Gibt es Aktualisierungsnebenwirkungen? (Wenn ja, welche?)" maxLength='20'
                       value={this.state.data_update_interval} placeholder="Das Aktualisierungsintervall in Min." slot='data_update_interval' update={this.update} />
         <ConfirmedText heading="Falls eine synchrone Schnittstelle aktiv ist: Gibt es Aktualisierungsnebenwirkungen? Wenn ja, welche?" placeholder="Beschreibung"
                        value={this.state.has_update_side_effect} value2={this.state.update_side_effect} slot='has_update_side_effect' slot2='update_side_effect' update={this.update} />
         <ConfirmedText heading="Gibt es einen Release-Plan oder geplante Weiterentwicklungen? Falls ja, bitte beschreiben Sie diese." placeholder="Beschreibung"
                        value={this.state.has_release_plan} value2={this.state.release_plan} slot='has_release_plan' slot2='release_plan' update={this.update} />
         <ConfirmedText heading="Sind Vorbereitungen für eine Installation notwendig?" placeholder="Beschreibung"
                        value={this.state.is_preparation_needed} value2={this.state.preparation_needed} slot='is_preparation_needed' slot2='preparation_needed' update={this.update} />
         <ConfirmedText heading="Gibt es Empfehlungen oder Erfahrungswerte zu Ihrer Software?" placeholder="Referenzen" value={this.state.has_customer_reference} value2={this.state.customer_reference} slot='has_customer_reference' slot2='customer_reference' update={this.update} />
         <ConfirmedText heading="Wird die Software schon erfolgreich eingesetzt?" placeholder="erfolgreich eingesetzt"
                        value={this.state.successful_deployment} value2={this.state.successful_deployment_description} slot='successful_deployment' slot2='successful_deployment_description' update={this.update} />
         <TextField heading="Welche sind die Einsatzbereiche Ihrer Software?" placeholder="Einsatzbereiche" maxLength='600' value={this.state.clinic_desc} slot='clinic_desc' update={this.update} />
         <IntegerField heading="Wieviele Nutzerinnen und Nutzer hat Ihre Software?" maxLength='20' value={this.state.user_number} placeholder="Nutzer Anzahl" slot='user_number' update={this.update} />
         <IntegerField heading="Wieviele davon sind Kliniken?" maxLength='20' value={this.state.clinic_number} placeholder="Anzahl der Kliniken" slot='clinic_number' update={this.update} />
         <ComplexityRate heading="Schätzen Sie: Wie komplex ist Ihre Software für Anwender?" complexityRate={complexityRate} obligatory={false} value={this.state.complexity_rate} slot='complexity_rate' update={this.update} />
         <ResearchSoftwareMinimalDatePicker heading="Seit wann ist Ihre Software in Nutzung?" value={this.state.date} slot='date' update={this.update} />

         <ComplexityRate heading="Wie schätzen Sie die mittlere Zufriedenheit der Nutzer(-innen) Ihrer Software ein?" complexityRate={satisfactionRate} obligatory={false} value={this.state.satisfaction_rate} slot='satisfaction_rate' update={this.update} />
         <TextField heading="Eine negative Zufriedenheit der Nutzer(-innen) kann begründet sein. Hier die Möglichkeit für eine Erklärung." maxLength='600' value={this.state.rating_desc} slot='rating_desc' update={this.update} />
 
         <MultipleFileUpload heading="Hier haben Sie die Möglichkeit, Ihr Produkt als eine Datei hochzuladen." value={this.state.product_files} slot="product_files" update={this.update} onNewMessage={this.props.onNewMessage} />
         {/* <CheckBox heading="* Erklärung zum Besitz" content="Bitte versichern Sie, dass das Angebotene entweder Ihnen gehört oder dass Ihre Institution, für die Sie anbieten, mit dem Anbieten einverstanden ist" value={this.state.agreement_1} slot='agreement_1' update={this.update} /> */}
        <div className="prodHeaderTexts margin-bottom3">* Erklärung zum Besitz</div>
        <div className="TextInfoText margin-bottom4">Bitte versichern Sie, dass die angebotene Software</div>
         <CheckBox content=" Sie oder Ihre Organisation die Rechte für den Verkauf haben." value={this.state.agreement_2} slot='agreement_2' update={this.update} />
         <CheckBox content="dass Sie nicht jemand anderes 'geistiges Eigentum' anbieten." value={this.state.agreement_3} slot='agreement_3' update={this.update} />
         <CheckBox content="Ihre Organisation, für die Sie anbieten, damit einverstanden ist." value={this.state.agreement_4} slot='agreement_4' update={this.update} />
         <CheckBox content="und Sie als Ansprechpartner zur Verfügung stehen.." value={this.state.agreement_6} slot='agreement_6' update={this.update} />
         {!util.isCommercialUser() &&
          <AGBCheckBox value={this.state.agb_agreement} slot='agb_agreement' agbUrl="/ueberlassungsvereinbarung.pdf"
                       content1="Ich habe die " fileType="Überlassungsvereinbarung" content2=" gelesen und akzeptiere diese." update={this.update} />}
          {util.isCommercialUser() &&
           <AGBCheckBox value={this.state.agb_agreement} slot='agb_agreement' agbUrl="/einstellvertrag.pdf"
                        content1="Ich habe den " fileType="Einstellvertrag" content2=" gelesen und akzeptiere diesen." update={this.update} />}<br />
           {!util.isCommercialUser() && <TextInfo content={checkBoxInfo} />}
           {!util.isCommercialUser() &&
            <CheckBox content="Ich erkläre mich bereit, dem Käufer unter der Verpflichtung, dies nicht ohne meine Genehmigung weiterzuverkaufen, den Quellcode zur Verfügung zu stellen." value={this.state.agreement_5} slot='agreement_5' update={this.update} />}
      
         </div>
         </div>
         <SubmitButton  history={this.props.history} onSubmit={this.save} />
         </div>
         </div>
         <Footer faqs={faqSoftware}/>
         </div>
        
        }
    
         {!util.isNonCommercialUser() && !util.isCommercialUser() &&
          <div>Sie besitzen nicht genügend Rechte, um eine Software zu erstellen.</div>
         }

      </div>
         );
  }
}



// WEBPACK FOOTER //
// ./src/new-software.js